<script setup>
import { computed} from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean, Array, Object],
    default: ''
  },
  pagesList: {
    type: [Array],
    default: []
  },
  darkMode: {
    type: Boolean,
    default: false
  },
})
//
const emit = defineEmits(['update:modelValue'])

const computedValue = computed({
  get: () => props.modelValue,
  set: value => {
    emit('update:modelValue', value)
  }
})

const next = () => {
  if(computedValue.value < props.pagesList.length-1){
    computedValue.value++;
  }
}

const prev = () => {
  if(computedValue.value > 0){
    computedValue.value--;
  }
}

</script>
<template>
  <admin-jb-buttons>

    <admin-jb-button
        v-if="computedValue !== 0"
        :key="-1"
        label="Previous"
        :outline="darkMode"
        small
        @click="prev()"
    />

    <admin-jb-button
        :key="0"
        :label="1"
        :outline="darkMode"
        :active="0 === computedValue"
        small
        @click="computedValue = 0"
    />

    <admin-jb-button
        v-if="(computedValue < 4 || pagesList.length-1 < 6) && 0 < pagesList.length-1"
        :key="2"
        :label="2"
        :outline="darkMode"
        :active="computedValue === 1"
        small
        @click="computedValue = 1"
    />

    <admin-jb-button
        v-if="(computedValue < 4 || pagesList.length-1 < 6) && 1 < pagesList.length-1"
        :key="3"
        :label="3"
        :outline="darkMode"
        :active="computedValue === 2"
        small
        @click="computedValue = 2"
    />


    <admin-jb-button
        v-if="(computedValue < 4 || pagesList.length-1 < 6) && 2 < pagesList.length-1"
        :key="4"
        :label="4"
        :outline="darkMode"
        :active="computedValue === 3"
        small
        @click="computedValue = 3"
    />

    <admin-jb-button
        v-if="(computedValue < 4 || pagesList.length-1 < 6)  && 3 < pagesList.length-1"
        :key="5"
        :label="5"
        :outline="darkMode"
        :active="computedValue === 4"
        small
        @click="computedValue = 4"
    />

    <admin-jb-button
        v-if="computedValue > 3 && computedValue < pagesList.length-1 && pagesList.length-1 > 6"
        key="..."
        label="..."
        :outline="darkMode"
        :active="false"
        small
    />

    <admin-jb-button
        v-if="computedValue > 3 && computedValue < pagesList.length-4"
        :key="computedValue"
        :label="computedValue"
        :outline="darkMode"
        :active="false"
        small
        @click="computedValue = computedValue-1"
    />

    <admin-jb-button
        v-if="computedValue > 3 && computedValue < pagesList.length-4"
        :key="computedValue+1"
        :label="computedValue+1"
        :outline="darkMode"
        :active="true"
        small
    />

    <admin-jb-button
        v-if="computedValue > 3 && computedValue < pagesList.length-4"
        :key="computedValue+2"
        :label="computedValue+2"
        :outline="darkMode"
        :active="false"
        small
        @click="computedValue = computedValue+1"
    />

    <admin-jb-button
        v-if="(computedValue < pagesList.length-4 || computedValue === pagesList.length-1) && pagesList.length-1 > 6"
        key=".."
        label="..."
        :outline="darkMode"
        :active="false"
        small
    />

    <admin-jb-button
        v-if="pagesList.length-1 === 6"
        key=".."
        label="..."
        :outline="darkMode"
        :active="false"
        small
    />

    <admin-jb-button
        v-if="(computedValue > pagesList.length-5 && 2 < pagesList.length-1) && pagesList.length-1 > 6"
        :key=" pagesList.length-4"
        :label="pagesList.length-4"
        :outline="darkMode"
        :active="computedValue ===  pagesList.length-5"
        small
        @click="computedValue =  pagesList.length-5"
    />

    <admin-jb-button
        v-if="(computedValue > pagesList.length-5 && 3 < pagesList.length-1) && pagesList.length-1 > 5 && !(pagesList.length-1 === 6 && computedValue < 4)"
        :key="pagesList.length-3"
        :label="pagesList.length-3"
        :outline="darkMode"
        :active="computedValue ===  pagesList.length-4"
        small
        @click="computedValue =  pagesList.length-4"
    />


    <admin-jb-button
        v-if="(computedValue > pagesList.length-5 && 4 < pagesList.length-1) && pagesList.length-1 > 5 && !(pagesList.length-1 === 6 && computedValue < 4)"
        :key="pagesList.length-2"
        :label=" pagesList.length-2"
        :outline="darkMode"
        :active="computedValue ===  pagesList.length-3"
        small
        @click="computedValue =  pagesList.length-3"
    />

    <admin-jb-button
        v-if="(((computedValue > pagesList.length-4 && pagesList.length-1 === 6) || (computedValue >= pagesList.length-4 && pagesList.length-1 !== 6)) && 5 < pagesList.length-1) && pagesList.length-1 > 5"
        :key="pagesList.length-1"
        :label="pagesList.length-1"
        :outline="darkMode"
        :active="computedValue ===  pagesList.length-2"
        small
        @click="computedValue =  pagesList.length-2"
    />

    <admin-jb-button
        v-if="pagesList.length-1 > 4"
        :key="pagesList.length"
        :label="pagesList.length"
        :outline="darkMode"
        :active="computedValue === pagesList.length-1"
        small
        @click="computedValue = pagesList.length-1"
    />

    <admin-jb-button
        v-if="computedValue !== pagesList.length-1"
        :key="-2"
        label="Next"
        :outline="darkMode"
        small
        @click="next()"
    />
  </admin-jb-buttons>
</template>


<style>

</style>
